import update from 'immutability-helper';

import {
  REGISTER_INIT_REQUEST,
  REGISTER_INIT_SUCCESS,
  REGISTER_INIT_FAILURE,
  REGISTER_VERIFY_REQUEST,
  REGISTER_VERIFY_SUCCESS,
  REGISTER_VERIFY_FAILURE,
  REGISTER_CREATE_USER_REQUEST,
  REGISTER_CREATE_USER_SUCCESS,
  REGISTER_CREATE_USER_FAILURE,
  REGISTER_SET_ERROR,
} from '../constants';

export const initialRegisterState = {
  referralId: null,
  contactId: null,
  type: 'AZINSIGHT',
  freeTrial: 10,
  wrapperStyle: {},
  loading: false,
  status: 'INIT' /** INIT / NOT_VERIFIED / VERIFIED */,
  error: '',
  showCouponCode: false,
  lockCouponCode: true,
  showHeaderImage: false,
  showHeaderSteps: false,
  couponCode: '',
  userInfo: {},
  showHeader: true,
  stepHeaders: {
    step1: '',
    step2: '',
    step3: '',
  },
  accessToken: '',
};

const reducer = (state = initialRegisterState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REGISTER_INIT_REQUEST:
      return update(state, {
        loading: {
          $set: true,
        },
        error: {
          $set: null,
        },
      });
    case REGISTER_INIT_SUCCESS:
      return update(state, {
        loading: {
          $set: false,
        },
        status: {
          $set: payload.status,
        },
        contactId: {
          $set: payload.contactId,
        },
      });
    case REGISTER_INIT_FAILURE:
      return update(state, {
        loading: {
          $set: false,
        },
        error: {
          $set: payload,
        },
      });

    case REGISTER_VERIFY_REQUEST:
      return update(state, {
        loading: {
          $set: true,
        },
        error: {
          $set: null,
        },
      });
    case REGISTER_VERIFY_SUCCESS:
      return update(state, {
        loading: {
          $set: false,
        },
        status: {
          $set: payload.status,
        },
        contactId: {
          $set: payload.contactId,
        },
      });
    case REGISTER_VERIFY_FAILURE:
      return update(state, {
        loading: {
          $set: false,
        },
        error: {
          $set: payload,
        },
      });

    case REGISTER_CREATE_USER_REQUEST:
      return update(state, {
        loading: {
          $set: true,
        },
        error: {
          $set: null,
        },
      });
      return update(state);
    case REGISTER_CREATE_USER_SUCCESS:
      return update(state, {
        loading: {
          $set: false,
        },
        status: {
          $set: 'SUCCESS',
        },
        userInfo: {
          $set: payload.userInfo,
        },
        accessToken: {
          $set: payload.accessToken,
        },
      });
    case REGISTER_CREATE_USER_FAILURE:
      return update(state, {
        loading: {
          $set: false,
        },
        error: {
          $set: payload,
        },
      });

    case REGISTER_SET_ERROR:
      return update(state, {
        error: {
          $set: payload,
        },
      });
    default:
      return state;
  }
};

export default reducer;
